<template>
  <v-container fluid class="payment-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn to="/payment/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-3" @click="isFindPayment=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              item-key="_id"
              v-model="data_selected"
              loading-text="Loading... Please wait"
              class="payments-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="headers"
              :items="data_payments"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Payment?
                    </v-card-title>
                    <v-card-text>
                      {{ deletepayment.paymentnum }} 
                      {{ deletepayment.paymentname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletepayment)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line">
                    <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                    </v-avatar>
                  </p>
                  <p class="two-line">
                    <span style="margin-left:5px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                  </p>
                </div>
              </template>
              <template v-slot:item.paymentimage="{ item }">
                    <v-img
                    v-if="item.paymentimage" 
                    v-bind:src="item.paymentimage"
                    max-height="60"
                    max-width="60"
                  ></v-img>
              </template>
              <template v-slot:item.isTaxable="{ item }">
                <v-icon v-if="item.isTaxable==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.paymentnum="{ item }">
                
                <p class="two-line">{{ item.paymenttype  }}</p>
                <p class="two-line">{{ item.paymentnum  }}</p>
                <p v-if="item.paymentdate!=undefined" class="two-line">{{ new Date(item.paymentdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                <p v-if="item.paymentduedate!==undefined" class="two-line"><b>Due: {{ new Date(item.paymentduedate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</b></p>
              </template>
              <template v-slot:item.paymentname="{ item }">
                <p class="two-line">{{ item.paymentname }}</p>
                <p class="two-line">{{ item.paymentaddress }}</p>
                <p class="two-line"><span style="font-size: 10pt; font-weight: bold;">Ref:</span> {{ item.refnum }}</p>
              </template>
              <template v-slot:item.locationid="{ item }">
                <p class="two-line">{{ locations.length>0 && locations.find(location=>location._id == item.locationid)!=null ? locations.find(location=>location._id == item.locationid)['locationname'] : '' }}</p>
                <p class="two-line">{{ accounts.length>0 && accounts.find(account=>account._id == item.accountid)!=null ? accounts.find(account=>account._id == item.accountid)['accountcode'] : '' }}</p>
              </template>
              <template v-slot:item.paymenttotal="{ item }">
                <p v-if="item.primaryCurrency" class="two-line"><span style="font-size: x-small;">{{ item.primaryCurrency }}</span> {{ item.paymenttotal.toFixed(2).toLocaleString('en-SG') }}</p>
                <p v-if="item.primaryCurrency!=item.secondaryCurrency" class="two-line"><span style="font-size: x-small;">{{ item.secondaryCurrency }}</span> {{ (item.paymenttotal * item.currencyRate).toFixed(2).toLocaleString('en-SG') }}</p>
              </template>
              <template v-slot:item.paymentstatus="{ item }">
                <v-chip
                  v-if="item.paymentstatus!=undefined"
                  :color="getStatusColor(item.paymentstatus)"
                  small
                >
                  {{ item.paymentstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.paymentstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindPayment"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Payments</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                              return {text: x.locationname, value: x._id};
                            })"
                    v-model="find_query.locationid"
                    label="Location"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="data_accounts"
                    v-model="find_query.accountid"
                    label="Payment From Account"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :items="['New', 'Pending', 'Partial', 'Completed', 'Audit', 'Void']"
                    v-model="find_query.paymentstatus"
                    label="Payment Status"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="Payment Num"
                    v-model="find_query.paymentnum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Payment Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_startdate"
                            v-model="menu_startdate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.startdate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.startdate"
                                label="Start Date"
                                v-bind="attrs"
                                v-bind:value="find_query.startdate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter start date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.startdate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_startdate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_startdate.save(find_query.startdate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_enddate"
                            v-model="menu_enddate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.enddate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.enddate"
                                label="End Date"
                                v-bind="attrs"
                                v-bind:value="find_query.enddate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter end date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.enddate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_enddate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_enddate.save(find_query.enddate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindPayment = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetPayments"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findPayments"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  <div class="text-center">
    <v-dialog
      v-model="dialogAlert"
      width="300"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Error</v-card-title>
        <v-card-text>
          {{ dialogMessage }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAlert = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';

export default {
  name: 'PaymentList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      isFindPayment: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      deletepayment: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      headers: [
        { text: 'Payment', value: 'paymentnum', sortable: false, width: '15%' },
        { text: 'Name', value: 'paymentname' },
        { text: 'Location & Account', value: 'locationid', width: '15%' },
        { text: 'Amount', value: 'paymenttotal', width: '15%' },
        { text: 'Created', value: 'userid', width: '10%' },
        { text: 'Status', value: 'paymentstatus', width: '10%' },
        { text: 'Tax', value: 'isTaxable', width: "2%" },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      data_payments: [],
      data_selected: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Payment', ['payments', 'isReceiving', 'isDeleting', 'idToDelete', 'paymentsMessage', 'isUpdating']),
    ...mapState('Department', ['departments']),
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('User', ['users']),
    data_accounts(){
      let result = this.accounts.filter(account=>account.accountsubclass=='Bank');
      let filter = this.accounts.filter(account=>account.accountname.includes('Accounts Receivable'));
      let results = [...result, ...filter];
      return results.map(x => { return {text: x.accountname, value: x._id} });
    },
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('Payment', ["getPaymentsRequest", "findPaymentsRequest", "deletePaymentRequest","updatePaymentRequest","createPaymentRequest"]),
    ...mapActions('Department', ["getDepartmentsRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('SalesChannel', ["getSalesChannelsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      let json = this.data_payments.map(payment=>{return {
        paymentnum: payment.paymentnum, 
        paymentdate: payment.paymentdate!=undefined ? new Date(payment.paymentdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        paymenttime: payment.paymentdate!=undefined ? new Date(payment.paymentdate).toLocaleString("en-SG", { hour: 'numeric', minute: 'numeric' }) : '',
        paymenttype: payment.paymenttype,
        name: payment.paymentname, 
        address: payment.paymentaddress,
        location: payment.locationid!=undefined && this.locations.length>0 ? this.locations.find(location=>location._id == payment.locationid)['locationname'] : '',
        department: payment.departmentid!=undefined && this.departments.length>0 ? this.departments.find(dept=>dept._id == payment.departmentid)['departmentname'] : '',
        channel: payment.channelid!=undefined && this.saleschannels.length>0 ? this.saleschannels.find(channel=>channel._id == payment.channelid)['channelname'] : '',
        adminrep: payment.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == payment.userid)['username'] : '',
        tax: payment.paymenttaxamount,
        subtotal: payment.paymentsubtotal,
        total: payment.paymenttotal,
        rate: payment.currencyRate,
      }});
      return json;
    },
    checkError(){
      if(this.data_selected.length==0) return false;
      if(this.data_selected.find(item=>item.paymentstatus=='Completed')!=null) return false;
      return true;
    },
    getFileName(){
      var d = new Date();
      var name = 'payments-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    editItem(item) {
      this.$router.push({ name: 'PaymentEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'PaymentPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'PaymentView', params: item });
    },
    async findPayments(){
      this.isFindPayment = false;
      if(Object.keys(this.find_query).length==0){
        await this.getPaymentsRequest();
        this.data_payments = Object.assign([], this.payments);
      }
      else{
        console.log('query')
        console.log(this.find_query)
        let result = await this.findPaymentsRequest(this.find_query);
        this.data_payments = Object.assign([], result);
      }
    },
    async resetPayments(){
      this.find_query = {};

    },
    async deleteItem(item) {
      await this.deletePaymentRequest({_id: item._id});
      this.data_payments = this.payments;
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletepayment = {
        _id: item._id,
        paymentnum: item.paymentnum,
        paymentname: item.paymentname,
      }
    },
  },
  async created () {
    if(this.payments.length==0) await this.getPaymentsRequest();
    this.data_payments = Object.assign([], this.payments);
    if(this.$route.params.payments!=null) this.data_selected = Object.assign([], this.$route.params.payments);

    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.departments.length==0) await this.getDepartmentsRequest();
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
